var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.hoverable,style:({ backgroundColor: _vm.color, padding: _vm.size }),attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }